// libraries
import React, { Component } from "react"
import { Route, Switch } from "react-router-dom"
// local modules
import SalesPage from "../pages/SalesPage"
import PurchasesPage from "../pages/PurchasesPage"
import EmployeesPage from "../pages/EmployeesPage"
import InventoriesPage from "../pages/InventoriesPage"
import InventoryPage from "../pages/InventoryPage"
import SalesReportPage from "../pages/SalesReportPage"
import DiscountPage from "../pages/DiscountPage"
import UkmPage from "../pages/UkmPage"
import {
  profilePage,
  analyticsPage,
  employeesPage,
  employeeProfilePage,
  cashboxPage,
  cashboxPageInfo,
  purchasesPage,
  salesPage,
  supplyPage,
  selectStorePage,
  inventoriesPage,
  inventoryPage,
  salesReportPage,
  discountPage,
  ukmPage,
  storagePage,
  productPage,
  paymentPage,
  reportsPage,
  reportPage,
  addProductPage,
  ncaLayerComponent,
} from "../config/routesInfo"
import SelectStorePage from "../pages/SelectStorePage"
import AnalyticsPage from "../pages/AnalyticsPage"
import NotFoundPage from "../pages/NotFoundPage"
import SupplyPage from "../pages/SupplyPage"
import CashboxPage from "../pages/CashboxPage"
import CashboxInfo from "../pages/CashboxInfo"
import EmployeeProfile from "../pages/EmployeeProfile"
import ProfilePage from "../pages/ProfilePage"
import StoragePage from "../pages/StoragePage"
import ProductPage from "../pages/ProductPage"
import PaymentPage from "../pages/PaymentPage"
import ReportsPage from "../pages/ReportsPage"
import ReportPage from "../pages/ReportPage"
import AddProductPage from "../pages/AddProductPage"
import NCALayerPage from "../pages/NCALayerPage"

export default class Router extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/" component={SelectStorePage} />
        <Route path={`/${profilePage.path}`} component={ProfilePage} />
        <Route path={`/${analyticsPage.path}`} component={AnalyticsPage} />
        <Route path={`/${employeesPage.path}`} component={EmployeesPage} />
        <Route
          path={`/${employeeProfilePage.path}`}
          component={EmployeeProfile}
        />
        <Route path={`/${cashboxPage.path}`} component={CashboxPage} />
        <Route path={`/${cashboxPageInfo.path}`} component={CashboxInfo} />
        <Route path={`/${purchasesPage.path}`} component={PurchasesPage} />
        <Route path={`/${salesPage.path}`} component={SalesPage} />
        <Route path={`/${supplyPage.path}`} component={SupplyPage} />
        <Route path={`/${discountPage.path}`} component={DiscountPage} />
        <Route path={`/${inventoriesPage.path}`} component={InventoriesPage} />
        <Route
          path={`/${inventoryPage.path}/:inventoryId`}
          component={InventoryPage}
        />
        <Route path={`/${selectStorePage.path}`} component={SelectStorePage} />
        <Route path={`/${salesReportPage.path}`} component={SalesReportPage} />
        <Route path={`/${ukmPage.path}`} component={UkmPage} />
        <Route path={`/${reportsPage.path}`} component={ReportsPage} />
        <Route path={`/${reportPage.path}/:type`} component={ReportPage} />
        {/*
          <Route path={`/${storagePage.path}`} component={StoragePage} />
          <Route path={`/${productPage.path}`} component={ProductPage} />
         */}
        {/* <Route path={`/${paymentPage.path}`} component={PaymentPage} />
         */}
        {/* 
          <Route path={`/${addProductPage.path}`} component={AddProductPage} />
         */}
        <Route path={`/${addProductPage.path}`} component={AddProductPage} />
        <Route path={`/${ncaLayerComponent.path}`} component={NCALayerPage} />
        <Route component={NotFoundPage} />
      </Switch>
    )
  }
}
// eslint-disable-next-line no-extend-native
String.prototype.capitalize = function() {
  return this.charAt(0).toUpperCase() + this.slice(1)
}
